import { TableRow } from "@mui/material"
import { computed } from "mobx"
import { observer } from "mobx-react-lite"
import { useMainStore } from "../../imacros-generator/store"
import EditorCell from "./editor"
import TableStore from "./store"
import { TableCell } from "./styled"
import { getCellStyle } from "./utils"

type Props = {
  index: number,
  style: React.CSSProperties,
  columns: { [key: string]: any },
  store: TableStore
}

const Row = observer(({ index, style, columns, store }: Props) => {
  
  const mainStore = useMainStore()
  const element = mainStore.arrayValues[index]
  const selectedKey = computed(() => store.getKey(index)).get()

  const selectCell = (key: string) => {
    if (columns[key].active && columns[key].active(element) === false) return
    store.setSelectedCell(index, key, columns[key])
  }

  const disabledColumns = new Set<string>()
  for (let key in columns) {
    if (columns[key].editable === false) {
      disabledColumns.add(key)
    }
    if (columns[key].active && columns[key].active(element) === false) {
      disabledColumns.add(key)
    }
  }

  return (
    <TableRow style={style} component="div">
      { Object.keys(element).map((key) => (
        <TableCell 
          onMouseDown={() => selectCell(key)} 
          key={key} 
          style={getCellStyle(columns[key].size)} 
          selected={key === selectedKey}
          disabled={disabledColumns.has(key)}
          edit={key === selectedKey && store.isEdit}
        >
          { (key === selectedKey && store.isEdit) ? (
            <EditorCell store={store} key="table-input"/>
          ): (
            (element as any)[key] ?? ""
          )}
        </TableCell>
      )) }
    </TableRow>
  )
})

export default Row